import { render, staticRenderFns } from "./userconfigurevip.vue?vue&type=template&id=6b5fc4e8&"
import script from "./userconfigurevip.vue?vue&type=script&lang=js&"
export * from "./userconfigurevip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports